import { toast, useToasts } from '../lib/toast';

const COLORS: Record<string, { bg: string; fg: string; border: string; icon: string }> = {
  info:    { bg: '#dbeafe', fg: '#1e40af', border: '#bfdbfe', icon: 'ℹ' },
  success: { bg: '#d1fae5', fg: '#065f46', border: '#a7f3d0', icon: '✓' },
  warning: { bg: '#fef3c7', fg: '#92400e', border: '#fde68a', icon: '⚠' },
  error:   { bg: '#fee2e2', fg: '#991b1b', border: '#fecaca', icon: '✗' },
};

export default function ToastHost() {
  const toasts = useToasts();
  if (toasts.length === 0) return null;
  return (
    <div
      style={{
        position: 'fixed',
        top: 16, right: 16,
        zIndex: 9999,
        display: 'flex', flexDirection: 'column', gap: 8,
        maxWidth: 460,
      }}
    >
      {toasts.map((t) => {
        const c = COLORS[t.kind] ?? COLORS.info;
        return (
          <div
            key={t.id}
            onClick={() => toast.dismiss(t.id)}
            style={{
              background: c.bg, color: c.fg, border: `1px solid ${c.border}`,
              padding: '10px 14px',
              borderRadius: 8,
              boxShadow: '0 4px 12px rgba(15,23,42,0.12)',
              fontSize: 13,
              cursor: 'pointer',
              display: 'flex', alignItems: 'flex-start', gap: 10,
              animation: 'toast-in 200ms ease-out',
            }}
          >
            <span style={{ fontSize: 16, fontWeight: 700, lineHeight: 1.2 }}>{c.icon}</span>
            <span style={{ flex: 1 }}>{t.text}</span>
            <span style={{ opacity: 0.5, fontSize: 11 }}>×</span>
          </div>
        );
      })}
    </div>
  );
}
